import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"

import "./footer.vue?vue&type=style&index=0&id=4fe68d90&scoped=true&lang=less"

import exportComponent from "E:\\A-OnlineServiceCenter\\stableBuilds\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe68d90"]])

export default __exports__